// Hide Express Checkout v2 — однократный запуск, без бесконечного observer
(function() {
  'use strict';
  
  var STYLE_ID = 'hulk-hide-express-checkout';
  var SELECTORS = [
    '.shopify-payment-button',
    '.shopify-payment-button__button',
    '[data-shopify="payment-button"]',
    '.additional-checkout-buttons',
    '.dynamic-checkout__content',
    '.dynamic-checkout__buttons',
    'shop-pay-wallet-button',
    'shop-pay-button',
    '[data-shop-pay]',
    '.paypal-button',
    '[data-paypal-button]',
    '.shopify-cleanslate',
    '[data-testid="Checkout-button"]',
    '.wallet-button',
    '.express-buttons',
    '.cart__dynamic-checkout-buttons',
    '.t4s-cart__dynamic-checkout-buttons',
    '[data-t4s-cart-dynamic-checkout]'
  ];
  
  function injectHideStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var styleEl = document.createElement('style');
    styleEl.id = STYLE_ID;
    styleEl.textContent = SELECTORS.map(function(s) {
      return s + ' { display: none !important; visibility: hidden !important; height: 0 !important; width: 0 !important; opacity: 0 !important; pointer-events: none !important; position: absolute !important; left: -9999px !important; }';
    }).join('\n');
    document.head.appendChild(styleEl);
  }
  
  function removeHideStyle() {
    var el = document.getElementById(STYLE_ID);
    if (el) el.remove();
  }
  
  function shouldHide(callback) {
    var path = window.location.pathname;
    
    if (path.indexOf('/products/') !== -1) {
      // На product page — проверяем DOM один раз
      callback(document.querySelector('.hulkapps_product_options') !== null);
      return;
    }
    
    // Везде кроме product — проверяем cart один раз
    fetch('/cart.json')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var hasHulkItems = cart.items && cart.items.some(function(item) {
          if (!item.properties) return false;
          return Object.keys(item.properties).some(function(key) {
            var val = item.properties[key];
            return typeof val === 'string' && (val.indexOf('[$') !== -1 || val.indexOf('[ $') !== -1);
          });
        });
        callback(hasHulkItems);
      })
      .catch(function() { callback(false); });
  }
  
  function check() {
    shouldHide(function(hide) {
      if (hide) injectHideStyle();
      else removeHideStyle();
    });
  }
  
  // Запускаем ОДИН раз при загрузке
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
  
  // И ещё раз через 2 сек на случай если Shop Pay подгрузится позже
  setTimeout(check, 2000);
  
  // Перепроверяем когда корзина меняется (стандартные события)
  ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function(evt) {
    document.addEventListener(evt, check);
  });
})();
